import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=17c196e6&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=17c196e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c196e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c196e6')) {
      api.createRecord('17c196e6', component.options)
    } else {
      api.reload('17c196e6', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=17c196e6&scoped=true&", function () {
      api.rerender('17c196e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/components/receive/confirm.vue"
export default component.exports